export const CALENDLY_URL = "https://calendly.com/yuyieldup/30min";
export const CALENDLY_HOUR_URL = "https://calendly.com/yuyieldup/new-meeting";
export const CALENDARS = {
  luciano: CALENDLY_URL,
  valerio: "https://calendly.com/valerio-pavano/15-minute-meeting-clone",
};
export const INSTAGRAM_URL = "https://instagram.com/yuyieldup";
export const EMAIL = "info@yuyieldup.it";
export const P_IVA = "";
export const CLIENT_AREA_URL = "https://app.yieldup.it/login";
export const SITE_URL = "https://yieldup.it";
export const WHATSAPP_NUMBER = "393479287328";
export const ARCHIFOTOGRAFIA_URL = "https://www.archifotografia.it";

export const whatsappUrl = (text) => `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  window.dispatchEvent(new CustomEvent("open-service", { detail: id }));
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -88, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const openService = (id) => {
  window.dispatchEvent(new CustomEvent("open-service", { detail: id }));
  scrollToId(id);
};

export const openLead = (interest = "") => {
  window.dispatchEvent(new CustomEvent("open-lead-modal", { detail: interest }));
};

export const openPrivacy = () => {
  window.dispatchEvent(new CustomEvent("open-privacy"));
};

export const openCallReason = (source = "") => {
  window.dispatchEvent(new CustomEvent("open-call-reason", { detail: source }));
};

export const openSopralluogo = (mode = "trasformare") => {
  window.dispatchEvent(new CustomEvent("open-sopralluogo", { detail: mode }));
};

export const bookCall = (reason, source = "", who = "luciano") => {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/call-intents`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ reason, source: `${source}${who !== "luciano" ? ` · ${who}` : ""}` }),
    });
  } catch {}
  const base = CALENDARS[who] || CALENDLY_URL;
  const sep = base.includes("?") ? "&" : "?";
  window.open(`${base}${sep}a1=${encodeURIComponent(reason)}`, "_blank", "noopener,noreferrer");
};

export const bookHour = () => {
  if (CALENDLY_HOUR_URL) {
    window.open(CALENDLY_HOUR_URL, "_blank", "noopener,noreferrer");
  } else {
    openLead("Un'ora con Luciano");
  }
};
